/**
 * Whether to mount the development-only devtools panels.
 *
 * They belong to a person debugging, not to the app, and the end-to-end suite drives the same
 * dev server a person does, so `import.meta.env.DEV` alone puts them in front of it: the
 * router panel's launcher sits bottom-right, over the footer of every drawer, and intercepts
 * the clicks a test aims at Save or Delete.
 *
 * `navigator.webdriver` is the standard signal for an automated browser and is set by
 * Playwright, so the panels stay for a developer and are absent under automation. It is read
 * defensively because this also runs where `navigator` is not a browser's.
 */
export function showDevChrome(): boolean {
    if (!import.meta.env.DEV) return false;
    return !(typeof navigator !== 'undefined' && navigator.webdriver);
}
